export const CANDIDATE_DOCUMENT_TYPES_SET_LOADING =
  '@candidate-document-types/set-loading';
export const CANDIDATE_DOCUMENT_TYPES_SET_TYPES =
  '@candidate-document-types/set-types';
export const CANDIDATE_DOCUMENT_TYPES_RESET_TYPES =
  '@candidate-document-types/reset-types';

export const CANDIDATE_DOCUMENT_TYPES_GET_TYPES =
  '@candidate-document-types/get-types';



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-document-types/types.js